import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

import { Translation as T } from "@awe-web/shared/lib";
import { Button, FormikErrorMessage, FormikRadioButton, FormikTextInput, LabeledRadioButton } from "../../../components/form.js";
import { Col, Row } from "../../../components/grid.js";
import { ScreenSectionHeading } from "../../../components/screen.js";

const DELIVERY_HEADING = "ALG0000148";
const DELIVERY_MAIL_LABEL = "ALG0000149";
const DELIVERY_MAIL_TEXT = "ALG0000150";
const DELIVERY_E_MAIL_LABEL = "ALG0000151";
const DELIVERY_E_MAIL_TEXT = "ALG0000152";
const DELIVERY_SUBMIT = "ALG0000153";

export default function BillDeliveryForm({values: {billDeliveryType}, handleSubmit}) {

  const formik = useFormikContext();
  const formikRef = useRef();
  formikRef.current = formik;

  useEffect(() => {
    if (billDeliveryType === "EMAIL") {
      formikRef.current.setFieldTouched("eBillingMailAddress", false);
    }
  }, [billDeliveryType]);

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col desktop={{ cols: 8, offset: 2 }}>
          <ScreenSectionHeading light><T code={DELIVERY_HEADING} /></ScreenSectionHeading>

          <LabeledRadioButton className="b2b-payment__radiobutton--mail">
            <FormikRadioButton name="billDeliveryType" value="MAIL" />
            <div className="b2b-payment__radiobutton__label-wrapper">
              <T className="b2b-payment__radiobutton__label" code={DELIVERY_MAIL_LABEL} />
              <T className="b2b-payment__radiobutton__text" code={DELIVERY_MAIL_TEXT} />
            </div>
          </LabeledRadioButton>
        </Col>
      </Row>

      <Row>
        <Col
          tablet={{ cols: 4 }}
          desktop={{ cols: 4, offset: 2 }}
        >
          <LabeledRadioButton className="b2b-payment__radiobutton--email">
            <FormikRadioButton name="billDeliveryType" value="EMAIL" />
            <div className="b2b-payment__radiobutton__label-wrapper">
              <T className="b2b-payment__radiobutton__label" code={DELIVERY_E_MAIL_LABEL} />
              <T className="b2b-payment__radiobutton__text" code={DELIVERY_E_MAIL_TEXT} />
              {billDeliveryType === "EMAIL"
                ? (
                  <>
                    <FormikTextInput
                      email
                      name="eBillingMailAddress"
                      className="b2b-payment__radiobutton__text-input"
                    />
                    <FormikErrorMessage name="eBillingMailAddress" />
                  </>
                )
                : null
              }
            </div>
          </LabeledRadioButton>
        </Col>
      </Row>
      <Row>
        <Col tablet={{ cols: 4, offset: 4 }} desktop={{ cols: 4, offset: 6 }} >
          <Button primary continue submit><T code={DELIVERY_SUBMIT} /></Button>
        </Col>
      </Row>
    </form>
  );
}

BillDeliveryForm.propTypes = {
  values: PropTypes.shape({
    billDeliveryType: PropTypes.oneOf(["MAIL", "EMAIL"])
  }),
  handleSubmit: PropTypes.func
};